import Vue from 'vue'
import Vuex from 'vuex'
import { vuexfireMutations, firestoreAction } from 'vuexfire'
import { db } from '@/helpers/firebase'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: '',
    sheets: [],
    variantControllers: []
  },
  getters: {
    getUser: state => state.user,
    sheets: (state) => {
      return state.sheets.filter(function(sheet) {
        return sheet.createdBy == state.user.uid
      })
    },
    // variantControllers: state => state.variantControllers

    variantControllers: (state) => (parentId) => {
      return state.variantControllers.filter(function(controller) {
        // Controllers will make it through the filter if their parentSheet property matches the passed in id that is pulled from the URL params
        return controller.parentSheet == parentId
      })
    }      
  },
  mutations: {
    SETTING_USER: (state, user) => (state.user = user),
    ...vuexfireMutations,
  },
  actions: {
    setUser: ({ commit }, user) => commit('SETTING_USER', user),
    bindSheets: firestoreAction(({ bindFirestoreRef }) => {
      // return the promise returned by `bindFirestoreRef`
      return bindFirestoreRef('sheets', db.collection('sheets'))
    }),
    bindVariantControllers: firestoreAction(({ bindFirestoreRef }) => {
      // return the promise returned by `bindFirestoreRef`
      return bindFirestoreRef('variantControllers', db.collection('variant-controllers'))
      })
  }
})